// extracted by mini-css-extract-plugin
export default {"formClas":"Form_formClas__VXJtj"};